/**
 * Path configuration that was previously in publicRuntimeConfig
 * These paths are used throughout the application for routing
 */

const providerEntryPointPath = 'account';
const appsPath = `${providerEntryPointPath}/apps`;
const settingsPath = `${providerEntryPointPath}/settings`;

export const paths = {
  base: '/v2',
  checkIn: '/check-in',
  waitingRoom: '/waiting-room',
  call: '/call',
  callHold: '/call/hold',
  testCall: '/call/test-call',
  dashboard: `/${providerEntryPointPath}/dashboard`,
  meetingHistory: `/${providerEntryPointPath}/meeting-history`,
  apps: `/${appsPath}`,
  appLibrary: `/${appsPath}/library`,
  appPrototypes: `/${appsPath}/prototypes`,
  analytics: `/${providerEntryPointPath}/analytics`,
  usersSettings: `/${settingsPath}/users`,
  extensionsPageAppletProvider: `/${providerEntryPointPath}/app`,
  accountSettings: `/${settingsPath}/account`,
  profileSettings: `/${settingsPath}/profile`,
  brandingSettings: `/${settingsPath}/branding`,
  waitingRoomSettings: `/${settingsPath}/room`,
  preferencesSettings: `/${settingsPath}/preferences`,
  baaSettings: `/${settingsPath}/baa`,
  appsSettings: `/${settingsPath}/apps`,
  subscriptionSettings: `/${settingsPath}/subscription`,
  clinicSettings: `/${settingsPath}/clinic`,
  roomsSettings: `/${settingsPath}/rooms`,
  customWaitingRoom: `/${settingsPath}/room/edit`,
  customBranding: `/${settingsPath}/branding/edit`,
  workspaceSelector: `/select-workspace`,
  iFrameInIframe: '/iframe-in-iframe',
  postLogin: '/post-login',
  logout: '/logout',
  signIn: '/sign-in',
  providerSelector: '/provider-selector',
  onboarding: '/onboarding',
  orderSuccess: '/order/success',
  checkYourEmail: '/check-your-email',
  notAvailable: `/${providerEntryPointPath}/not-available`,
};
